import { render, staticRenderFns } from "./IconEmailNewsletter.vue?vue&type=template&id=f3b669ae&"
import script from "./IconEmailNewsletter.vue?vue&type=script&lang=js&"
export * from "./IconEmailNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports